// Sentry must be imported first for proper error tracking
import { initSentry } from "@/lib/sentry";

// Initialize Sentry before any other code runs
initSentry();

// Initialize PostHog for analytics
import { initPostHog, trackAppOpen } from "@/lib/posthog";
initPostHog();

// Initialize Capacitor for native platforms
import { initializeCapacitor } from "@/utils/capacitor";
initializeCapacitor();

// Track app open on initial load
trackAppOpen();

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
